import {action, observable, makeObservable} from 'mobx';
import {packageConsts} from '../../../../constants';
import {getLocalizedText, texts} from '../../../../constants/TextConst';

export class Packages {
    /* packages data accessible via package id */
    @observable packages;
    screensToUpdate;

    constructor() {
        makeObservable(this);
    }

    initPackages() {
        if (!this.packages) {
            this.packages = observable.map({
                [packageConsts.NO_PACKAGE]: {title: getLocalizedText(texts.withoutPack)}
            });
        }
    }

    @action
    resetPackages() {
        for (const p of this.packages.keys()) {
            const pack = this.packages.get(p);
            if (pack.initialHidden !== undefined) {
                pack.hidden = pack.initialHidden;
                delete pack.initialHidden;
            }
        }
    }

    @action
    addPackageDataItem(packId, data) {
        this.packages.set(packId, {
            title: data.title,
            category: data.category,
            hidden: data.packageHidden,
            moduleHidden: false /*data.moduleHidden*/,
            help: data.help,
            unusedPack: data.unusedPack
        });
    }

    @action
    setPackages(packages) {
        this.packages = packages;
    }

    /* this function should be called when screen is loaded for the first time */
    addScreenKey(key) {
        this.screensToUpdate[key] = false;
    }

    setScreensChanged(changedScreenName) {
        for (const key in this.screensToUpdate) {
            if (key !== changedScreenName) {
                this.screensToUpdate[key] = true;
            }
        }
    }

    getFieldPack(packId) {
        return packId ? this.packages.get(packId) : null;
    }

    hideOrShowPack(packageId, newHiddenStatus) {
        const pack = this.packages.get(packageId);
        if (pack) {
            if (!pack.initialHidden) {
                pack.initialHidden = pack.hidden;
            }
            pack.hidden = !pack.hidden;
        } else {
            this.addPackageDataItem(packageId, {hidden: newHiddenStatus, unusedPack: true});
        }
    }
}

export const packagesStore = new Packages();
